if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.calculateEndDate();
      this.timer = this.timer.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    calculateEndDate() {
      const now = new Date();
      const daysUntilThursday = (4 - now.getDay() + 7) % 7;
      const nextThursday = new Date(now);
      nextThursday.setDate(now.getDate() + daysUntilThursday);
      nextThursday.setHours(22, 0, 0, 0); // Set to 22:00:00

      // If it's already past 22:00 on Thursday, set the date to next week
      if (now >= nextThursday) {
        nextThursday.setDate(nextThursday.getDate() + 7);
      }

      this.endDate = nextThursday.getTime();
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer, this.second);
    }

    timer() {
      const now = new Date().getTime();
      const timeDiff = this.endDate - now;

      if (timeDiff < 0) {
        this.calculateEndDate(); // Calculate next end date
        this.endDate = this.endDate + 7 * this.day; // Add 7 days to endDate
        return; // Skip updating the UI as the date has just been recalculated
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor((timeDiff % this.day) / this.hour);
      const mins = Math.floor((timeDiff % this.hour) / this.minute);
      const secs = Math.floor((timeDiff % this.minute) / this.second);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = hours;
      this.minsEl.textContent = mins;
      this.secsEl.textContent = secs;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}